export default {
	setFooters(state, footers) {
		state.footers = footers
	},
}
